import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import HomePage from "./pages/HomePage";
import ProductsPage from "./pages/ProductsPage";
import ChiSiamoPage from "./pages/ChiSiamoPage";
import ContattiPage from "./pages/ContattiPage";
import DetrazioniPage from "./pages/DetrazioniPage";
import PremiPage from "./pages/PremiPage";
import PrivacyPage from "./pages/PrivacyPage";
import TerminiPage from "./pages/TerminiPage";
import AdminPage from "./pages/AdminPage";
import AdminLoginPage from "./pages/admin/AdminLoginPage";

const SITE_NAME = "Koreko Direct";
const PAGE_TITLES = {
  "/": `${SITE_NAME} — Infissi, Vetrate e Pergole a Gaeta`,
  "/prodotti": `Prodotti — Infissi PVC, Alluminio e Pergole | ${SITE_NAME}`,
  "/chi-siamo": `Chi Siamo | ${SITE_NAME}`,
  "/contatti": `Contatti e Preventivo Gratuito | ${SITE_NAME}`,
  "/detrazioni-fiscali": `Detrazioni Fiscali 50% | ${SITE_NAME}`,
  "/premi": `Premi e Riconoscimenti | ${SITE_NAME}`,
  "/privacy": `Privacy Policy | ${SITE_NAME}`,
  "/termini-condizioni": `Termini e Condizioni | ${SITE_NAME}`,
  "/admin/login": `Accesso Admin | ${SITE_NAME}`,
  "/admin": `Pannello Admin | ${SITE_NAME}`,
};

// Aggiorna il titolo della scheda a ogni cambio di pagina.
function PageTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    const key = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
    document.title = PAGE_TITLES[key] || SITE_NAME;
  }, [pathname]);
  return null;
}

// Layout pubblico: header + footer + toaster inclusi.
function PublicLayout() {
  return (
    <>
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}

// Layout admin: nessun header/footer del sito, il pannello disegna la sua chrome.
function AdminLayout() {
  return <Outlet />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PageTitle />
        <Routes>
          {/* Sito pubblico */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/prodotti" element={<ProductsPage />} />
            <Route path="/chi-siamo" element={<ChiSiamoPage />} />
            <Route path="/contatti" element={<ContattiPage />} />
            <Route path="/detrazioni-fiscali" element={<DetrazioniPage />} />
            <Route path="/premi" element={<PremiPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/termini-condizioni" element={<TerminiPage />} />
          </Route>

          {/* Area admin */}
          <Route element={<AdminLayout />}>
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Route>
        </Routes>
        <Toaster position="bottom-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
